var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardChart',{attrs:{"input":_vm.chartData,"legend":true,"chartType":"bar"}})
}
var staticRenderFns = []

export { render, staticRenderFns }